import styled from 'styled-components'

import {Container} from '~/components/general/container/Container'
import {StyledContainer} from '~/components/general/container/Container.styled'
import {STACK_OFFSET_PX} from '~/utils/servicesReportPlacement'
import {theme} from '~/styles/theme'

const BASE_TRACK_HEIGHT = 72

const getStatusBorderColor = (
  status: 'onsite' | 'scheduled' | 'complete',
): string => {
  switch (status) {
    case 'onsite':
      return theme.colors.indicator.border.green
    case 'scheduled':
      return theme.colors.indicator.border.orange
    case 'complete':
      return theme.colors.indicator.border.red
    default:
      return theme.colors.indicator.border.red
  }
}

export const TimelineContainer = styled(Container)`
  width: 100%;
  background: ${theme.colors.grey.grey20};
  border-radius: 8px;
  border: 1px solid ${theme.colors.grey.grey100};
  padding: 8px;
`

export const MonthHeaderGrid = styled(Container)<{$columns: number}>`
  display: grid;
  grid-template-columns: repeat(${({$columns}) => $columns}, 1fr);
  gap: 8px;
  margin-bottom: 8px;
`

export const MonthHeader = styled(Container)<{
  $colStart: number
  $colEnd: number
}>`
  grid-column: ${({$colStart, $colEnd}) => `${$colStart} / ${$colEnd}`};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.colors.grey.grey40};
  border: 1px dashed ${theme.colors.grey.grey100};
  border-radius: 6px;
  padding: 4px 6px;
`

export const ServicesStack = styled(Container)`
  width: 100%;
`

export const ServiceRow = styled(Container)<{
  $columns: number
  $maxStackLevel: number
}>`
  display: grid;
  grid-template-columns: repeat(${({$columns}) => $columns}, 1fr);
  gap: 8px;
  position: relative;
  min-height: ${({$maxStackLevel}) =>
    BASE_TRACK_HEIGHT + $maxStackLevel * STACK_OFFSET_PX}px;
  width: 100%;
`

export const ServiceGridItem = styled(StyledContainer)<{
  $colStart: number
  $colEnd: number
  $stackLevel: number
}>`
  grid-column: ${({$colStart, $colEnd}) => `${$colStart} / ${$colEnd}`};
  grid-row: 1;
  align-self: start;
  min-width: 0;
  width: 100%;
  margin-top: ${({$stackLevel}) => $stackLevel * STACK_OFFSET_PX}px;
  z-index: ${({$stackLevel}) => $stackLevel + 1};
  cursor: pointer;
`

export const ServiceBlock = styled(Container)<{
  $status: 'onsite' | 'scheduled' | 'complete'
}>`
  background: ${theme.colors.primary.blue50};
  border: 2px solid ${({$status}) => getStatusBorderColor($status)};
  border-radius: 6px;
  padding: 6px 8px;
  min-width: 0;
  word-break: break-word;
  &:hover {
    filter: brightness(0.98);
  }
`

export const PageContainer = styled(Container)`
  height: 100%;
`

export const GridWrapper = styled(Container)`
  flex: 1;
  min-height: 0;
  overflow: auto;
`

export const LegendBar = styled(Container)`
  align-self: flex-start;
`

export const LegendChip = styled(Container)<{
  $status: 'onsite' | 'scheduled' | 'complete'
}>`
  border: 2px solid ${({$status}) => getStatusBorderColor($status)};
  border-radius: 8px;
  padding: 6px 12px;
  background: ${theme.colors.white};
`
